// Auto-generated icon module
const svg = `<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
<g transform="translate(3 3)">
	<path d="M9,1.1L15.9,5L9,8.9L2.1,5L9,1.1 M9,0L0,5l9,5l9-5L9,0z" />
	<polygon points="18,11.7 9,16.7 0,11.7 1,11.2 9,15.6 17,11.1" />
	<polygon points="18,8.5 9,13.5 0,8.5 1,8 9,12.4 17,7.9" />
</g>
</svg>
`;

export { svg as default };
//# sourceMappingURL=it-piattaforme-BiUeZjZk.js.map
